import * as a from '../actions/accountant'
import { createReducer } from 'redux-act'
import moment from 'moment'
const month = (new Date().getMonth() + 1);
const DEFAULT_STATE = {
  data: [],
  allData: [],
  filter: JSON.parse(window.localStorage.getItem('accountingPersonlFilter')) || {
    status: "accounting",
    year: new Date().getFullYear(),
    month: month < 10 ? "0" + month : month,
    employee: "-1"
  }
};
export default createReducer(
  {
    [a.getAccountingRequestsSuccessful]: (state, payload) => {
      return {
        ...state,
        allData: payload,
        data: payload.filter((request) => {
         const month = moment(request.costs.costDate).format("MM");
         const year  = moment(request.costs.costDate).format("YYYY");
         return request.costs.status == state.filter.status && month == state.filter.month && year == state.filter.year;
        })
      }
    },
    [a.getAccountingRequestsFailure]: (state, payload) => {
      return {
        ...state
      }
    },
    [a.accountingRequestConfirmSuccessful]: (state, payload) => {
      let allData = state.allData;
      let data = state.data;
      if (payload) {
        allData = state.allData.filter((data) => data.costs.costId != payload);
        data = state.data.filter((data) => data.costs.costId != payload);
      } else {
        allData = [];
        data = [];
      }

      return {
        ...state,
        allData: allData,
        data: data
      }
    },
    [a.accountingRequestConfirmFailure]: (state, payload) => {
      return {
        ...state
      }
    },
    [a.accountingRequestCancelSuccessful]: (state, payload) => {
      let allData = state.allData;
      let data = state.data;
      if (payload) {
        allData = state.allData.filter((data) => data.costs.costId != payload);
        data = state.data.filter((data) => data.costs.costId != payload);
      } else {
        allData = [];
        data = [];
      }

      return {
        ...state,
        allData: allData,
        data: data
      }
    },
    [a.accountingRequestCancelFailure]: (state, payload) => {
      return {
        ...state
      }
    },
    [a.confirmAllCostSuccessful]: (state, payload) => {
      return {
        ...state,
        allData: [],
        data: []
      }
    },
    [a.confirmAllCostFailure]: (state, payload) => {
      return {
        ...state
      }
    },
    [a.setFilter]: (state, payload) => {
        localStorage.setItem('accountingPersonlFilter',JSON.stringify(payload))
      if (payload.year == -1)
        payload.year = window.costStartingYear;
      return {
        ...state,
        filter: payload,
        data: state.allData.filter((request) => {
          let date = request.costs.costDate.split("/");
          return (payload.employee == "-1" || payload.employee == request.user.employees._id) && (request.costs.status == payload.status) && date[1] == payload.month && date[2] == payload.year;
        })
      }
    },
  },
  DEFAULT_STATE
);
